import { Component } from '@angular/core';
import { SidebarService } from './sidebar.service';

@Component({
  selector: 'ml-sidebar-button',
  templateUrl: './sidebar-button.component.html',
  standalone: false,
})
export class SidebarButtonComponent {
  constructor(private readonly sidebarService: SidebarService) {}

  /**
   * Toggles the sidebar visibility.
   */
  public toggleSidebar(): void {
    const state = !this.sidebarService.getVisibilityState();
    this.sidebarService.setVisibilityState(state);
  }
}
